<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px" />

          <div class="row mb-2">
            <div class="col-sm-12">
              <div v-if="flag">
                <span class="badge badge-success">Total Search Data Found: {{ union_trainees.length }}</span>
                <download-excel class="btn btn-light float-right" :data="union_trainees" :fields="union_fields"
                  :meta="json_meta" worksheet="Trainee" name="Union.xls">
                  Download Excel
                </download-excel>

                <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                  <div v-if="loading" class="spinner-border spinner-border-sm text-muted" style="margin-bottom : 2px;">
                  </div>
                  Download PDF
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
                <tr>
                  <th>Sl</th>
                  <th>Union Name</th>
                  <th>18-25 Age</th>
                  <th>26-35 Age</th>
                  <th>36-45 Age</th>
                  <th>46+ Age</th>
                  <th>Male</th>
                  <th>Female</th>
                  <th>Total Trainee</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(union_trainee, index) in union_trainees" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ union_trainee.desc }}</td>
                  <td>{{ union_trainee.total_age_count.twentyFive }}</td>
                  <td>{{ union_trainee.total_age_count.thirtyFive }}</td>
                  <td>{{ union_trainee.total_age_count.forthFive }}</td>
                  <td>{{ union_trainee.total_age_count.oneHundredTwenty }}</td>
                  <td>{{ union_trainee.traineeMaleCount ? union_trainee.traineeMaleCount : 0 }}</td>
                  <td>{{ union_trainee.traineeFemaleCount ? union_trainee.traineeFemaleCount : 0 }}</td>
                  <td>{{ union_trainee.total_trainee }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td>{{ union_trainees_age_count.twenty_five }}</td>
                  <td>{{ union_trainees_age_count.thirty_five }}</td>
                  <td>{{ union_trainees_age_count.forty_five }}</td>
                  <td>{{ union_trainees_age_count.forty_six_plus }}</td>
                  <td>{{ union_trainees_age_count.male }}</td>
                  <td>{{ union_trainees_age_count.female }}</td>
                  <td>{{ union_trainees_age_count.total }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h5 v-if="union_trainees.length === 0" class="text-center text-secondary">
            No Data Found
          </h5>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
  page: {
    title: "Union Information",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      loading: false,
      title: "Union Information",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Union Information",
          active: true
        }
      ],
      union_trainees: [],
      union_trainees_age_count: {
        twenty_five: 0,
        thirty_five: 0,
        forty_five: 0,
        forty_six_plus: 0,
        male: 0,
        female: 0,
        total: 0
      },
      union_fields: {
        'Union Name': 'desc',
        '18-25 Age': 'total_age_count.twentyFive',
        '26-35 Age': 'total_age_count.thirtyFive',
        '36-45 Age': 'total_age_count.forthFive',
        '46+ Age': 'total_age_count.oneHundredTwenty',
        'Male': {
          callback: (value) => {
            return `${value.traineeMaleCount ? value.traineeMaleCount : "0"}`;
          }
        },
        'Female': {
          callback: (value) => {
            return `${value.traineeFemaleCount ? value.traineeFemaleCount : "0"}`;
          }
        },
        'Total Trainee': 'total_trainee',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      flag: false,
    };
  },

  mounted() {
    this.getUnionTrainee();
  },
  methods: {
    async dowonloadPdf() {
      this.loading = true
      // let response = await http.post("api/trainees/age/download_trainees", this.search_data);
      var data = []
      try {
        // console.log(this.mouza_trainees)
        // return
        this.union_trainees.forEach(function (value) {
          data.push([
            value.desc,
            value.total_age_count.twentyFive,
            value.total_age_count.thirtyFive,
            value.total_age_count.forthFive,
            value.total_age_count.oneHundredTwenty,
            value.total_trainee
          ])
        })
      }
      catch (e) {
        console.log(e.message)
      }

      const doc = new jsPDF()
      autoTable(doc, {
        head: [['Union name', '18-25 Age', '26-35 Age', '36-45 Age', '46+', 'Total']],
        body: data,
      })
      doc.save('union-followup-age-report.pdf')
      this.loading = false
    },
    getUnionTrainee() {
      http.get("api/union/trainee/age/list").then(response => {
        if (!response.error) {
          this.flag = true;
          this.union_trainees = response.data.union_trainees;

          //total counts
          this.union_trainees.forEach(union => {
            this.union_trainees_age_count.twenty_five += union.total_age_count.twentyFive
            this.union_trainees_age_count.thirty_five += union.total_age_count.thirtyFive
            this.union_trainees_age_count.forty_five += union.total_age_count.forthFive
            this.union_trainees_age_count.forty_six_plus += union.total_age_count.oneHundredTwenty
            this.union_trainees_age_count.male += union.traineeMaleCount
            this.union_trainees_age_count.female += union.traineeFemaleCount
            this.union_trainees_age_count.total += union.total_trainee
          });
        }
      });
    },
  },
};
</script>
